import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Back from "../../common/assets/images/Back.svg";
import Close from "../../common/assets/images/Close.svg";
import { DialogTitle,useMediaQuery } from "@mui/material";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

import "../../dataEntry/styles/DataEntry.scss";
import { Box, padding } from "@mui/system";
import Reports from "../../dataEntry/components/Reports";

const ViewReport = (props) => {
  const closeDialog = (e) => {
    e.preventDefault();
    props.onClose();
  };
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <React.Fragment>
      <Dialog
        fullWidth={props.fullWidth}
        maxWidth={props.maxWidth}
        open={props.open}
        onClose={props.onClose}
        className={isMobile ? 'report-dialogMobile' : 'report-dialog'}
      >
        <DialogTitle style={{ borderBottom: "0.8px solid #f0f1fc" }}>
          <Link
            to="/"
            className="FIle-left"
            onClick={closeDialog} 
            style={{width:isMobile && "10px",marginRight:"10px"}} >
            <img
              src={Back}
              className="file-img-left"
              alt=""
              style={{width:isMobile && "10px",marginRight:"10px"}}
         
            />
          </Link>
          <span style={{fontSize:isMobile && "12px"}}>Reports</span>
          <Link to="/" className="FIle-right-extreme" onClick={closeDialog}>
            <img src={Close} className="file-img-extreme-right" alt="" 
                style={{width:isMobile && "10px",marginTop:isMobile && "10px"}} />
          </Link>
        </DialogTitle>
        <DialogContent style={{padding:"5px"}}>
          <Reports selectedPatient={props.selectedPatient} />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};
export default ViewReport;
